/* IMPERIAL TIME MOTION SYSTEM V1
   Functional motion only. No autoplay gallery behaviour is introduced. */
(function(){
  'use strict';

  var reduceMotion=window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Smooth FAQ details without changing semantic <details>/<summary> behaviour. */
  function initFaq(root){
    (root||document).querySelectorAll('.ituk-faq details.ituk-faq__item').forEach(function(detail){
      if(detail.dataset.itMotionReady==='1') return;
      var summary=detail.querySelector(':scope > summary');
      var answer=detail.querySelector(':scope > .ituk-faq__a');
      if(!summary || !answer) return;
      detail.dataset.itMotionReady='1';

      summary.addEventListener('click',function(event){
        if(reduceMotion){
          return;
        }
        event.preventDefault();
        if(detail.dataset.itAnimating==='1') return;
        detail.dataset.itAnimating='1';

        if(detail.open){
          var current=answer.getBoundingClientRect().height;
          var closeAnimation=answer.animate([
            {height:current+'px',opacity:1,transform:'translateY(0)'},
            {height:'0px',opacity:0,transform:'translateY(-4px)'}
          ],{
            duration:220,
            easing:'cubic-bezier(.4,0,.2,1)'
          });
          closeAnimation.onfinish=function(){
            detail.open=false;
            answer.style.removeProperty('height');
            answer.style.removeProperty('opacity');
            answer.style.removeProperty('transform');
            detail.dataset.itAnimating='0';
          };
          closeAnimation.oncancel=function(){detail.dataset.itAnimating='0';};
        }else{
          detail.open=true;
          var target=answer.scrollHeight;
          var openAnimation=answer.animate([
            {height:'0px',opacity:0,transform:'translateY(-4px)'},
            {height:target+'px',opacity:1,transform:'translateY(0)'}
          ],{
            duration:280,
            easing:'cubic-bezier(.22,.61,.36,1)'
          });
          openAnimation.onfinish=function(){
            answer.style.removeProperty('height');
            answer.style.removeProperty('opacity');
            answer.style.removeProperty('transform');
            detail.dataset.itAnimating='0';
          };
          openAnimation.oncancel=function(){detail.dataset.itAnimating='0';};
        }
      });
    });
  }

  /* PDP image zoom follows pointer position but remains user-controlled. */
  function initPdpZoom(root){
    if(reduceMotion || !window.matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)').matches) return;
    (root||document).querySelectorAll('body.imperial-watch-page .imperial-watch-pdp .imperial-watch-hero__media .product__media').forEach(function(media){
      if(media.dataset.itZoomReady==='1' || !media.querySelector('img')) return;
      media.dataset.itZoomReady='1';
      media.addEventListener('pointermove',function(event){
        var rect=media.getBoundingClientRect();
        if(!rect.width || !rect.height) return;
        var x=Math.max(0,Math.min(100,((event.clientX-rect.left)/rect.width)*100));
        var y=Math.max(0,Math.min(100,((event.clientY-rect.top)/rect.height)*100));
        media.style.setProperty('--it-pdp-zoom-x',x.toFixed(1)+'%');
        media.style.setProperty('--it-pdp-zoom-y',y.toFixed(1)+'%');
      },{passive:true});
      media.addEventListener('pointerleave',function(){
        media.style.setProperty('--it-pdp-zoom-x','50%');
        media.style.setProperty('--it-pdp-zoom-y','50%');
      },{passive:true});
    });
  }

  function init(root){
    initFaq(root);
    initPdpZoom(root);
  }

  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',function(){init(document);},{once:true});
  }else{
    init(document);
  }

  /* Shopify sections and dynamically replaced collection content. */
  document.addEventListener('shopify:section:load',function(event){init(event.target);});
  document.addEventListener('shopify:section:select',function(event){init(event.target);});

  var observer=new MutationObserver(function(mutations){
    var shouldInit=false;
    for(var i=0;i<mutations.length;i++){
      if(mutations[i].addedNodes && mutations[i].addedNodes.length){shouldInit=true;break;}
    }
    if(shouldInit) init(document);
  });
  observer.observe(document.documentElement,{childList:true,subtree:true});
})();
